import type { ReactNode } from 'react';

export type Column<Row> = {
  key: string;
  header: ReactNode;
  /** 渲染单元格 */
  cell: (row: Row) => ReactNode;
  width?: string | number;
  align?: 'left' | 'center' | 'right';
  whiteSpace?: 'normal' | 'nowrap';
};

type Props<Row> = {
  columns: ReadonlyArray<Column<Row>>;
  rows: ReadonlyArray<Row>;
  rowKey: (row: Row) => string;
  empty?: ReactNode;
};

export function DataTable<Row>({ columns, rows, rowKey, empty }: Props<Row>) {
  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            {columns.map((c) => (
              <th
                key={c.key}
                style={{
                  width: c.width,
                  textAlign: c.align ?? 'left',
                  whiteSpace: c.whiteSpace ?? 'nowrap',
                }}
              >
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="table-empty">
                {empty ?? '暂无数据'}
              </td>
            </tr>
          ) : (
            rows.map((r) => (
              <tr key={rowKey(r)}>
                {columns.map((c) => (
                  <td
                    key={c.key}
                    style={{
                      textAlign: c.align ?? 'left',
                      whiteSpace: c.whiteSpace ?? 'nowrap',
                    }}
                  >
                    {c.cell(r)}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
